import React from 'react';
import { Link } from 'react-router-dom';

const ContactInfo = () => {
    return (
        <section className="backlight-top divider-bottom">
            <div className="stg-row infocolors-section-title">
                <div className="stg-col-8 stg-offset-2">
                    <div className="align-center">
                        <h2 data-appear="fade-up" data-unload="fade-up">Let's 🗣 talk!</h2>
                        <p className="infocolors-large-text" data-appear="fade-up" data-delay="100" data-unload="fade-up">Here's how you can connect with the infocolors team:</p>
                    </div>
                </div>
            </div>
            <div className="stg-row" data-stagger-appear="fade-up" data-delay="200" data-stagger-unload="fade-up">
                <div className="stg-col-4 stg-tp-col-6 stg-tp-bottom-gap">
                    <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                        <Link to="tel:+12345556789" className="infocolors-grid-item-link"></Link>
                        <div>
                            <h5>Phone<span className="infocolors-accent">.</span></h5>
                            <h6>+234 (0) 70-6700-9743</h6>
                        </div>
                        <p>Give us a call and chat directly with our friendly team. We're always happy to answer any questions.</p>
                    </div>
                </div>
                <div className="stg-col-4 stg-tp-col-6 stg-tp-bottom-gap">
                    <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                        <Link to="mailto:infocolors@example.com" className="infocolors-grid-item-link"></Link>
                        <div>
                            <h5>Email<span className="infocolors-accent">.</span></h5>
                            <h6>the.infocolors@gmail.com</h6>
                        </div>
                        <p>Send us a detailed message. We'll get back to you as soon as possible to discuss your creative project further.</p>
                    </div>
                </div>
                <div className="stg-col-4 stg-tp-col-12">
                    <div className="infocolors-block stg-aspect-square stg-tp-aspect-rectangle stg-vertical-space-between">
                        <div>
                            <h5>Social Media<span className="infocolors-accent">.</span></h5>
                            <ul className="infocolors-socials-list stg-small-gap" data-stagger-appear="fade-up" data-stagger-delay="75">
                               <li>
                                    <Link to="https://web.facebook.com/the.infocolors" target="_blank" className="infocolors-socials-facebook">
                                        <i></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.instagram.com/the_infocolors/" target="_blank" className="infocolors-socials-instagram">
                                        <i></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://x.com/the_infocolors" target="_blank" className="infocolors-socials-x">
                                        <i></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://www.tiktok.com/@the_infocolors?lang=en" target="_blank" className="infocolors-socials-tiktok">
                                        <i></i>
                                    </Link>
                                </li>
                                {/*  <li>
                                    <Link to="#" target="_blank" className="infocolors-socials-patreon">
                                        <i></i>
                                    </Link>
                                </li> */}
                            </ul>
                        </div>
                        <p>Follow us on Social Media Platforms for a glimpse into our creative world, industry insights, and projects.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactInfo;
